export default __webpack_public_path__ + "static/banner-tampons-1-a7418c16a70295eb769ab74e6f109f7c.png";